export default __webpack_public_path__ + "static/support-sponsor-rbc-eb3af73d209c8f5d11582a05409f4f77.png";